export const COOKIE_NAME = {
    clubStatus: 'clubStatus',
    optanonConsent: 'OptanonConsent',
} as const;

export const CLUB_STATUS_COOKIE_VALUE = {
    club: 'club',
    nonClub: 'nonClub',
    leftClub: 'leftClub',
} as const;
